import { render, staticRenderFns } from "./omt-page.vue?vue&type=template&id=48bd461b&"
import script from "./omt-page.vue?vue&type=script&lang=js&"
export * from "./omt-page.vue?vue&type=script&lang=js&"
import style0 from "./omt-page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports